import { render, staticRenderFns } from "./EmployeeGroups.vue?vue&type=template&id=7cd06fe8"
import script from "./EmployeeGroups.vue?vue&type=script&lang=ts"
export * from "./EmployeeGroups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports